<div class="mx-auto flex max-w-screen-md flex-col justify-center space-y-8 p-6">
    <h1>Page not found!</h1>
    <div class="">
        Not all who wander are lost.<br />
        But you are definitely lost.
    </div>
    <a
        class="mx-0 w-auto rounded-full bg-red px-6 py-4 text-center text-white"
        [routerLink]="['/']"
        >Go to homepage</a
    >
</div>
